import { JobManagementModel } from '@app/origami-api/services/job-management.service';
import { EventEmitter } from '@angular/core';
import { JobStatus, ErrorCode } from '@app/origami-api/constants';

export class BackgroundJob {
  readonly startTime: Date = new Date();

  get errorCode() {
    return this._errorCode;
  }
  get completed() {
    return this._completed;
  }
  get inProgress() {
    return this._inProgress;
  }
  get succeed() {
    return this._succeed;
  }
  get canceled() {
    return this._canceled;
  }
  get canceling() {
    return this._canceling;
  }
  get completedWithErrors() {
    return this._completedWithErrors;
  }
  get status() {
    return this._jobStatus;
  }
  get progress() {
    return this._progress;
  }
  get result() {
    return this._result;
  }

  readonly change = new EventEmitter<BackgroundJob>();
  readonly done = new EventEmitter<BackgroundJob>();

  private _result: JobManagementModel;
  private _completed = false;
  private _inProgress = true;
  private _succeed = false;
  private _canceled = false;
  private _canceling = false;
  private _completedWithErrors = false;
  private _errorCode = ErrorCode.SUCCESS;
  private _jobStatus = JobStatus.InQueue;
  private _progress: { total: number; current: number; action: string };

  constructor(
    public readonly siteId: number,
    public readonly id: string,
    public readonly title: string,
    public readonly roomName?: string,
  ) {}

  update(result: JobManagementModel) {
    this._result = result;

    const errorCodeSuccess = !!result && result.ErrorCode === ErrorCode.SUCCESS;
    const finished = !!result && result.Status === JobStatus.Finished;
    const canceled = !!result && (result.Status === JobStatus.Canceled || result.Status === JobStatus.Canceling);

    this._errorCode = result ? result.ErrorCode : ErrorCode.SUCCESS;
    this._jobStatus = result ? <JobStatus>result.Status : JobStatus.InQueue;
    this._completed = !!result && (!errorCodeSuccess || finished || canceled);
    this._inProgress =
      (!this._completed && this._jobStatus === JobStatus.Processing) || this._jobStatus === JobStatus.InQueue;
    this._succeed = finished && this._errorCode === ErrorCode.SUCCESS;
    this._canceled = canceled || this._errorCode === ErrorCode.JOB_DOES_NOT_EXIST;
    this._canceling = this._jobStatus === JobStatus.Canceling;
    this._completedWithErrors = this._completed && !!this._errorCode;

    this._progress =
      errorCodeSuccess && !this._canceled
        ? {
            total: result.ProgressTotal || 0,
            current: result.ProgressCurrent || 0,
            action: result.Action || '',
          }
        : null;

    this.change.emit(this);
    if (this._completed) {
      this.done.emit(this);
    }
  }
}
